<template>
    <div>
        <el-button type="primary" plain @click="returnPage">返回</el-button>
        <div class="demo-image__lazy">
            <el-image :src="url" lazy></el-image>
        </div>
    </div>
</template>
<script>
export default {
    data() {
        return {
            url: '',
            id: ''
        };
    },
    created() {
        this.id = this.$route.query.id;
        console.log(this.id);
        this.getSysInfoList();
    },
    methods: {
        getSysInfoList() {
            this.$axios
                .post('banner/getData', {
                    id: this.id
                })
                .then(res => {
                    console.log(res);
                    if (res.data.code == 0) {
                        this.url = res.data.data.bannerUrl;
                        this.$message.success('获取轮播图成功');
                    } else {
                        this.$message.error(res.data.data);
                    }
                });
        },
        returnPage() {
            // 跳转上一级
            // 这个判断用来解决这种情况，当用户没有上一条路由的历史记录，出现点击返回按钮没有反应时，下面的代码用来判断有没有上一条路由的历史记录   如果没有则返回首页
            if (window.history.length <= 1) {
                this.$router.push({ path: '/home' });
                return false;
            } else {
                this.$router.go(-1);
            }
        }
    }
};
</script>
<style scoped>
.el-button{
    margin-bottom: 20px;
    width: 80px;
    font-size: 14px;
    font-weight: bold;
}
.demo-image__lazy{
    text-align: center;
}
</style>
